import parsePhoneNumber, { isValidPhoneNumber } from 'libphonenumber-js'

export const validatePhoneNumber = (number) => {
  const parsedNumber = parsePhoneNumber(number)
  return(!parsedNumber || !isValidPhoneNumber(parsedNumber.number) || parsedNumber)
}
